export const SUPER_ADMIN = 'SUPER_ADMIN';

export const MERCHANT_SUPER_ADMIN = 'MERCHANT_SUPER_ADMIN';
export const MERCHANT_ADMIN = 'MERCHANT_ADMIN';
export const ADMIN = 'ADMIN';

export const SECURITY_ADMIN = 'SECURITY_ADMIN';

export const HOT_DEALS = 'Best sellers';
